import 'react-app-polyfill/ie9'; // For IE 9-11 support
import 'react-app-polyfill/ie11'; // For IE 11 support
import './polyfill'
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import $ from 'jquery';
import { getPreferredLanguage } from './common/localizationManager';

document.addEventListener('DOMContentLoaded', onDocumentLoad);

function onDocumentLoad() {
    console.log("onDocumentLoad")
    var lang = getPreferredLanguage();
    $("html").attr("dir", lang && lang.isRTL ? "rtl" : "ltr")
}

function onDocumentUnload() {
    console.log("onDocumentUnload")
}

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();